import React from 'react'
import Styled from 'styled-components'

import ColorBox from 'editor/ColorBox'

const Option = Styled.div`
  position: relative;
`

const Color = Styled.div`
  position: relative;
  height: 0;
  padding-bottom: 75%;
`

const ColorContent = Styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`

const Label = Styled.div`
  margin-top: 0.5rem;
  font-family: ${props => props.theme.fonts.regular};
  color: ${props => props.theme.colors.gray.shade400};
  font-size: 0.7rem;
  font-weight: 600;
  text-align: center;
`

export default props => (
  <Option>
    <Color>
      <ColorContent>
        <ColorBox
          align={props.align}
          value={props.value}
          onChange={props.onChange}
        />
      </ColorContent>
    </Color>
    <Label>{props.label}</Label>
  </Option>
)



// WEBPACK FOOTER //
// ./src/components/ThemeColor/index.js